import { useEffect, useState } from 'react';
import { Outlet, useLocation } from 'react-router-dom';
import SuperAdminSidebar from './SuperAdminSidebar';
import SuperAdminNavbar from './SuperAdminNavbar';
import './AppLayout.css';

export default function SuperAdminLayout() {
  const location = useLocation();
  const activePage = location.pathname.split('/')[2] || 'dashboard';
  const [sidebarOpen, setSidebarOpen] = useState(false);

  useEffect(() => { setSidebarOpen(false); }, [location.pathname]);

  return (
    <div className="layout">
      <SuperAdminSidebar isOpen={sidebarOpen} onClose={() => setSidebarOpen(false)} />
      {sidebarOpen && <div className="layout__overlay" onClick={() => setSidebarOpen(false)} />}
      <div className="layout__body">
        <SuperAdminNavbar activePage={activePage} onToggleSidebar={() => setSidebarOpen((o) => !o)} />
        <main className="layout__content">
          <Outlet />
        </main>
      </div>
    </div>
  );
}
